import { Passenger } from '../passenger.model';
import { Reservation } from '@app/models/micro/reservation.model';
import {
  FLIGHT_ITINERARY_TYPE,
  FLIGHT_ITINERARY_TYPE_MICRO,
  PAX_TYPE,
  PAX_TYPE_SHORT,
} from '@app/enums';
import { ResidenceAddressInt } from '@app/interfaces/requiredDocuments.interface';

export class RequestRequireDocumentsModel {
  reservationCode: string;
  tripType: string;
  bookedLegCollection: BookedLegCollection[];
  passengers: Passengers[];

  constructor(reservation: Reservation) {
    const flightType = {
      [FLIGHT_ITINERARY_TYPE.ONEWAY]: FLIGHT_ITINERARY_TYPE_MICRO.ONEWAY,
      [FLIGHT_ITINERARY_TYPE.ROUNDTRIP]: FLIGHT_ITINERARY_TYPE_MICRO.ROUNDTRIP,
      [FLIGHT_ITINERARY_TYPE.MULTICITY]: FLIGHT_ITINERARY_TYPE_MICRO.MULTICITY,
    };

    this.reservationCode = reservation.pnr;
    this.tripType = flightType[reservation.flightItineraryType];
    this.bookedLegCollection = [new BookedLegCollection(reservation.flightSummary)];
    this.passengers = reservation.passengers.map(
      (passenger) => new Passengers(passenger, reservation)
    );
  }
}

export class BookedLegCollection {
  codeShare = false;
  legCode: string;
  legEntity: string;
  legRegion: string;
  selectedLeg = true;
  segments: Segments[];

  constructor(leg) {
    this.legCode = leg?.legCode;
    this.legEntity = leg?.legEntity;
    this.legRegion = leg?.legRegion;
    this.segments = leg.segments?.map((segment) => new Segments(segment)) || [
      new Segments(leg.currentSegment),
    ];
  }
}

export class Segments {
  bookingClass: string;
  departureAirport: string;
  departureDateTime: string;
  operatingCarrier: string;
  operatingFlightCode: string;
  segmentCode: string;
  segmentStatusCode: string;
  windowSegmentStatus: string;

  constructor(segment) {
    this.segmentCode = segment?.segmentCode;
    this.departureAirport = segment?.departureAirport;
    this.departureDateTime = segment?.departureDateTime;
    this.operatingCarrier = segment?.operatingCarrier;
    this.operatingFlightCode = segment?.operatingFlightCode;
    this.segmentStatusCode = segment?.segmentStatusCode;
    this.bookingClass = segment?.bookingClass;
    this.windowSegmentStatus = segment?.windowSegmentStatus || null;
  }
}

export class Passengers {
  selectedForCheckin = true;
  firstName: string;
  lastName: string;
  passengerNameNumber: string;
  gender: string;
  email: any[];
  phone: any[];
  type: string;
  birthDate: string;
  passengerInfant: string;
  emergencyContact: any;
  residenceAddress: ResidenceAddressInt;
  countryOfResidence: string;
  eticket: string;

  constructor(passenger: Passenger, reservation) {
    const paxType = {
      [PAX_TYPE.ADULT]: PAX_TYPE_SHORT.ADULT,
      [PAX_TYPE.CHILD]: PAX_TYPE_SHORT.CHILD,
      [PAX_TYPE.INFANT]: PAX_TYPE_SHORT.INFANT,
    };

    this.passengerNameNumber = passenger?.nameRefNumber;
    this.firstName = passenger.firstName;
    this.lastName = passenger.lastName;
    this.birthDate = passenger.dateOfBirth || null;
    this.gender = passenger.gender.substring(0, 1) || null;
    this.type = paxType[passenger.paxType];
    this.passengerInfant = passenger?.passengerInfant !== '' ? passenger.passengerInfant : null;
    this.emergencyContact = passenger.passengerInfo.emergencyContact
      ? this.objP(passenger.passengerInfo.emergencyContact)
      : undefined;
    this.countryOfResidence =
      reservation.codeShare && passenger.passengerInfo.countryResidence
        ? passenger.passengerInfo.countryResidence
        : undefined;
    this.residenceAddress =
      !reservation.codeShare && passenger.passengerInfo.countryResidence
        ? this.objResidence(passenger.passengerInfo.countryResidence)
        : undefined;
    this.eticket = passenger.ticketInfo?.eticket;
  }

  objP(passenger) {
    return {
      fullName: passenger?.fullName,
      phoneNumber: {
        countryCode: !passenger?.phoneNumber?.countryCode
          ? 'Mex'
          : passenger?.phoneNumber?.countryCode,
        number: passenger?.phoneNumber?.number?.replaceAll(' ', ''),
      },
      relation: !passenger.relation ? 'Otra relacion' : passenger?.relation,
    };
  }
  objResidence(countryResidence) {
    return {
      country: countryResidence,
    };
  }
}

export class ParamsPassengerListUpgradeRQ {
  departureAirport: string;
  departureDate: string;
  operatingCarrier: string;
  operatingFlightCode: string;

  constructor(parameters) {
    this.departureAirport = parameters.bookedLegCollection[0].segments[0].departureAirport;
    this.departureDate = parameters.bookedLegCollection[0].segments[0].departureDateTime;
    this.operatingCarrier = parameters.bookedLegCollection[0].segments[0].operatingCarrier;
    this.operatingFlightCode = parameters.bookedLegCollection[0].segments[0].operatingFlightCode;
  }
}
